(function ($) {
  $(document).ready(function () {
    $('[data-toggle=collapse]').on('click', function () {
      var target = $(this).data('target');
      $(target).toggleClass('show');
      $(this).find('span').toggleClass('show');
    });
  });
}(jQuery));
